import {create} from 'zustand';

const useDataStore = create((set) => ({
  data: null,
  setData: (data) => set({ data }),
  renewalData: null,
  setRenewalData: (renewalData) => set({ renewalData }),
}));

export default useDataStore;
